

























import {Component, Vue, Inject} from 'vue-property-decorator';
import Footer from '../components/Footer.vue'
import TenantSwitch from '../components/tenant-switch.vue'
// import LanguageSwitch from '../components/language-switch.vue'
import iView from 'iview';
import AbpBase from '../lib/abpbase'

@Component({
	components: {Footer, TenantSwitch}
})
export default class Login extends AbpBase {
	showLogin = false
	loginModel = {
		userNameOrEmailAddress: '',
		password: '',
		rememberMe: false
	}
	showChangeTenant: boolean = false
	created(){
		let self = this;
		document.onkeydown = function (e) {
			let key = (window.event as any).keyCode;
			if (key == 13) {
				self.login()
			}
			if (key === 113) {
				self.showLogin = !self.showLogin
			}
		}
		const currentLanguage = abp.utils.getCookieValue("Abp.Localization.CultureName")
		if (currentLanguage !== "zh-Hans") {
			abp.utils.setCookieValue(
				"Abp.Localization.CultureName",
				"zh-Hans",
				new Date(new Date().getTime() + 5 * 365 * 86400000), //5 year
				abp.appPath
			);
			// setTimeout(location.reload(),2000)
			location.reload();
		}
	}

	async login() {
		// (this.$refs.loginform as any).validate(async (valid: boolean) => {
		// 	if (valid) {
				this.$Message.loading({
					content: '正在登录',
					duration: 0
				})
				await this.$store.dispatch({
					type: 'app/login',
					data: this.loginModel
				})
				sessionStorage.setItem('rememberMe', this.loginModel.rememberMe ? '1' : '0');
				location.reload();
		// 	}
		// });
	}

	get tenant() {
		return this.$store.state.session.tenant;
	}

	rules = {
		userNameOrEmailAddress: [
			{required: true, message: this.L('UserNameRequired'), trigger: 'blur'}
		],
		password: [
			{required: true, message: this.L('PasswordRequired'), trigger: 'blur'}
		]
	}

}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/login3.vue